import React from 'react';
import { Block } from '@mui/icons-material';
import leg1 from "../img/leg/leg1.png";
import leg2 from "../img/leg/leg2.png";
import leg3 from "../img/leg/leg3.png";
import leg4 from "../img/leg/leg4.png";

const Leg = ({ onImageClick }) => {
  return (
    <>
      <div className="help-center__examples help-center__examples--first">
        <div className="help-center__examples-header">
          <Block />
          <h3 className="help-center__examples-title">Common leg positioning mistakes to avoid</h3>
        </div>
        
        <div className="help-center__example-card">
          <div className="help-center__example-images help-center__example-images--grid-4">
            <div className="help-center__image-placeholder help-center__image-placeholder--dont">
              <div className="help-center__image-label">Don't</div>
              <div className="help-center__image-box">
                <img src={leg1} alt="Incorrect leg positioning example 1" onClick={() => onImageClick && onImageClick(leg1)} style={{cursor: 'pointer'}} />
              </div>
              <div className="help-center__image-caption">
                Leg is not supposed to pass though a mirror in the bathroom
              </div>
            </div>
            
            <div className="help-center__image-placeholder help-center__image-placeholder--dont">
              <div className="help-center__image-label">Don't</div>
              <div className="help-center__image-box">
                <img src={leg2} alt="Incorrect leg positioning example 2" onClick={() => onImageClick && onImageClick(leg2)} style={{cursor: 'pointer'}} />
              </div>
              <div className="help-center__image-caption">
                Her left leg appearing on the right side does not match with the left side
              </div>
            </div>
            
            <div className="help-center__image-placeholder help-center__image-placeholder--dont">
              <div className="help-center__image-label">Don't</div>
              <div className="help-center__image-box">
                <img src={leg3} alt="Incorrect leg positioning example 3" onClick={() => onImageClick && onImageClick(leg3)} style={{cursor: 'pointer'}} />
              </div>
              <div className="help-center__image-caption">
                Her right leg as a problem
              </div>
            </div>
            
            <div className="help-center__image-placeholder help-center__image-placeholder--dont">
              <div className="help-center__image-label">Don't</div>
              <div className="help-center__image-box">
                <img src={leg4} alt="Incorrect leg positioning example 4" onClick={() => onImageClick && onImageClick(leg4)} style={{cursor: 'pointer'}} />
              </div>
              <div className="help-center__image-caption">
                Triple leg
              </div>
            </div>
          </div>
          
       
        </div>
      </div>
    </>
  );
};

export default Leg;